import React, { useEffect } from 'react';
import { MapPin } from 'lucide-react';
import { trackCTAClick, trackSectionView } from '../utils/analytics';

const HeroSection = () => {
  useEffect(() => {
    // Track hero section view
    const timer = setTimeout(() => {
      trackSectionView('hero_section', 1000);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleCTAClick = () => {
    trackCTAClick('Découvrir les spots', 'hero_main_cta');
  };

  return (
    <section className="hero-critical">
      <div className="hero-content">
        <div className="hero-card">
          <picture>
            <source srcSet="/logo-96.webp" type="image/webp" />
            <img 
              src="/logo-96.png" 
              alt="Sun-Spot Logo" 
              className="w-20 h-20 mx-auto mb-8 rounded-xl object-cover shadow-lg"
              width="80"
              height="80"
            />
          </picture>
          
          <h1 className="hero-title">
            Sun Spot : Découvrez et partagez vos <span className="text-orange-500">spots panoramiques</span> préférés
          </h1>
          
          <p className="text-xl text-amber-700 mb-8 leading-relaxed">
            Trouvez les plus beaux points de vue et lieux secrets près de chez vous
          </p>

          <p className="text-lg text-gray-700 mb-10 leading-relaxed max-w-3xl mx-auto">
            Sun Spot est une plateforme gratuite pour découvrir des spots panoramiques exceptionnels, 
            bancs avec vue, lieux calmes et endroits secrets où contempler et se ressourcer. 
            Explorez des points de vue uniques et partagez vos spots préférés avec la communauté.
          </p>

          <button 
            onClick={handleCTAClick}
            className="inline-flex items-center bg-gradient-to-r from-orange-500 to-amber-500 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:from-orange-600 hover:to-amber-600 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <MapPin className="w-6 h-6 mr-3" />
            Découvrir les spots
          </button>
        </div>

        {/* Stats Cards */}
        <div className="grid md:grid-cols-3 gap-6 mt-16">
          <div className="bg-white/60 backdrop-blur-md rounded-xl p-6 text-center hover:bg-white/70 transition-all duration-200">
            <div className="text-4xl font-bold text-amber-600 mb-2">100%</div>
            <div className="text-amber-700 font-medium">Gratuit</div>
          </div>
          
          <div className="bg-white/60 backdrop-blur-md rounded-xl p-6 text-center hover:bg-white/70 transition-all duration-200">
            <div className="text-4xl font-bold text-amber-600 mb-2">∞</div>
            <div className="text-amber-700 font-medium">Spots à découvrir</div>
          </div>
          
          <div className="bg-white/60 backdrop-blur-md rounded-xl p-6 text-center hover:bg-white/70 transition-all duration-200">
            <div className="text-4xl font-bold text-amber-600 mb-2">🤝</div>
            <div className="text-amber-700 font-medium">Communauté</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;